<template>
  <!-- prettier-ignore -->
  <div
    class="ab-config"
    data-is-onboarding-route-based="true"
  />
</template>

<script>
/**
 * data-is-onboarding-route-based
 * controls, how the onboarding is triggered on the basket screen
 * true = onboarding-route is active and used
 * false = onboarding is shown in modal
 *
 * data-is-price-widget-form-interactive
 * controls, how the person-form is shown in pricewidgets
 * true = form is "inline"
 * false = form is opened in modal
 */
export default {
  name: 'ABConfig',

  mounted() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
          this.updateValues()
        }
      })
    })
    observer.observe(this.$el, { attributes: true })

    this.updateValues()
  },

  methods: {
    updateValues() {
      for (const key in this.$el.dataset) {
        this.$abConfig.set(key, this.$el.dataset[key])
      }
    },
  },
}
</script>

<style scoped>
.ab-config {
  display: contents;
}
</style>
